<template>
    <div>
        <LabelComponent :definition="definition" :is-locked="isLocked"/>
        <v-text-field dense filled
                      :readonly="isLocked"
                      type="number"
                      :value="value"
                      @input="change($event)"
                      hide-details="auto"
        ></v-text-field>
    </div>
</template>

<script>

    import _ from 'lodash';
    import TranslationService from "../../../services/TranslationService";
    import LabelComponent from "./LabelComponent";

    import FormComponentMixin from "../../mixins/form-component";

    export default {
        name: "NumberComponent",
        components: {
            LabelComponent
        },
        mixins: [

        ],
        props: [
            "value",
            'definition',
            'isLocked'
        ],
        data() {
            return {

            }
        },
        watch: {

        },
        computed: {

        },
        methods: {
            change(event) {
                let number = Number.parseFloat(event);
                if (Number.isNaN(number)) {
                    number = null;
                }
                this.$emit('input', number);
            },
        }
    }
</script>

<style scoped>

</style>
